/**
 * To store the user language
 */
export const LS_KEY_USER_LANG = "language";
